import React, { FC } from "react";
import { FormControl, Autocomplete, TextField, Chip, Box } from "@mui/material";
import styles from './MultiSelectField.module.css';

interface MultiSelectFieldProps {
  label: string;
  value: string[];
  onChange: (value: string[]) => void;
  options: { nome: string }[];
  required?: boolean;
  fullWidth?: boolean;
  placeholder?: string;
  error?: boolean;
  helperText?: React.ReactNode;
}

const MultiSelectField: FC<MultiSelectFieldProps> = ({
  label,
  value,
  onChange,
  options,
  required,
  fullWidth = true,
  placeholder = "",
  error,
  helperText,
}) => {
  return (
    <FormControl fullWidth={fullWidth}>
      <Autocomplete
        slotProps={{
          paper: {
            className: styles.paper,
          },
          popper: {
            className: styles.popper,
          },
        }}
        multiple
        options={options.map((option) => option.nome)} // Usa apenas strings
        value={value}
        onChange={(_, newValue) => onChange(newValue)}
        filterSelectedOptions
        renderInput={(params) => (
          <>
            <label className={styles.titleInput}>
              {label}
            </label>
            <TextField
              {...params}
              label=""
              variant="standard"
              required={required}
              fullWidth={fullWidth}
              error={error}
              helperText={helperText}
              placeholder={value.length === 0 ? placeholder : ''}
              InputProps={{
                ...params.InputProps,
                className: styles.inputSelect, // estiliza o input real
                disableUnderline: true,
              }}
              InputLabelProps={{
                className: styles.labelSelect, // estiliza o label
                shrink: true,
              }}
            />
          </>
        )}
        renderTags={(selected, getTagProps) => (
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.2 }}>
            {selected.map((option, index) => (
              <Chip {...getTagProps({ index })} key={option} label={option} />
            ))}
          </Box>
        )}
      />
    </FormControl>
  );
};

export default MultiSelectField;
